import Counter from "./components/Counter/TabCounter";
import Label from "./components/Label/TabLabel";
import LeftIcon from "./components/LeftIcon/TabLeftIcon";
import RightIcon from "./components/RightIcon/TabRightIcon";

export interface ITabExtensions {
    Label: typeof Label;
    Counter: typeof Counter;
    LeftIcon: typeof LeftIcon;
    RightIcon: typeof RightIcon;
}

export const tabExtensions: ITabExtensions = {
    Counter,
    Label,
    LeftIcon,
    RightIcon,
};
